import { FormBuilder, UntypedFormGroup, FormArray, FormControl } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter, HostListener, SimpleChanges, ElementRef } from '@angular/core';


@Component({
  selector: 'app-btn-filter-checkbox',
  templateUrl: './btn-filter-checkbox.component.html',
  styleUrls: ['./btn-filter-checkbox.component.scss']
})
export class BtnFilterCheckboxComponent implements OnInit {

  isShow = false;
  _formGroup: UntypedFormGroup;
  @Input() list = [];
  @Output() handleEventSelected = new EventEmitter();
  itemsSelected = [];


  constructor( private eRef: ElementRef) { }

  ngOnInit(): void {
  }

  show(){
    this.isShow = !this.isShow
  }

  @HostListener('document:click', ['$event'])
  outsideClick(event){
    if(!this.eRef.nativeElement.contains(event.target)) {
      this.isShow = false
    }
  }

  handleCheckChange(event){
      if(this.itemsSelected.map(itemSelected => itemSelected).includes(event.source.value)){
        this.itemsSelected = this.itemsSelected.filter(item => item !== event.source.value);
      }else {
        this.itemsSelected.push(event.source.value);
      }
      this.handleEventSelected.emit(this.itemsSelected);
  }


}
